import { usePage } from '@inertiajs/react';
import React, { createContext, useContext } from 'react';

export type InterpolationCtxType = Record<string, unknown>;

export const InterpolationContext = createContext<InterpolationCtxType>({});

export function InterpolationProvider({ children }: { children: React.ReactNode }) {
    const { props } = usePage<{ dataContext?: InterpolationCtxType }>();
    return <InterpolationContext.Provider value={props.dataContext ?? {}}>{children}</InterpolationContext.Provider>;
}

export function useInterpolationCtx() {
    return useContext(InterpolationContext);
}
